import loadable from '@loadable/component'
import {createOverlayType} from '../../../../contexts/overlay-manager'

const SearchOverlay = loadable(() => import('./internal'))

export const {
    useOverlay: useSearchOverlay,
    useIsOpen: useIsSearchOverlayOpen,
    preload: preloadSearchOverlay
} = createOverlayType(SearchOverlay)
